/* global wp, wpUser, ajaxVars, FWP, FWP_HTTP */
// ----- bable-polyfill enables ES6 - promis and async.
// ----- whatwg-fetch we need for api fetch functions.
import 'babel-polyfill'; // eslint-disable-line import/no-unassigned-import
import 'whatwg-fetch'; // eslint-disable-line import/no-unassigned-import
import store from 'store/dist/store.modern';
import expirePlugin from 'store/plugins/expire';
import shave from 'shave';
import eqcol from 'eqcol';
import debounce from 'lodash.debounce';
import './dropdown';
import Navbar from './behaviors/navbar';
import Footer from './behaviors/footer';
import Profile from './behaviors/profile';
import { getStoredLocationData } from './deprecated';

store.addPlugin(expirePlugin);
// Identifier for API calls (old).
// ----- Currently only used for apiSurvey.
const SITE_ID = 'ProfileYuriTest';

// Experience levels
const EXP_LEVEL_NONE = 0;

// Experience levels not in use
// const EXP_LEVEL_BEGINNER = 1;
// const EXP_LEVEL_EXPLORER = 2;
// const EXP_LEVEL_VETERAN = 3;

// Wrapper for common ajax calls
const getAsync = args => {
	const deferred = $.Deferred();

	$.ajax(args).then(response => {
		deferred.resolve(response);

	}).catch(err => {
		deferred.reject(err);
	});

	return deferred.promise();
};




//=================================
//----- GC-PERSONALIZER ADD ON ----
//=================================
// ----- We no longer use apiProfile

// const apiProfile = {
// 	// url: 'https://tker6jp00k.execute-api.us-west-2.amazonaws.com/dev/',
// 	// apiKey: 'H1kQyXDxHS8oK0T2WpWd88r40zQYrNay8tfqS7RH',
// 	url: 'https://dev-api.givingcompass.org/v1/profile',
// 	apiKey: 'euRWXq7JPipZJNmznTdKZvaKCM7N4fa2',

// 	async fetch(email) {
// 		const ajaxArgs = {
// 			url: apiProfile.url + email,
// 			data: 'SiteId=' + SITE_ID,
// 			type: 'get',
// 			dataType: 'json',
// 			headers: {
// 				'x-api-key': apiProfile.apiKey
// 			}
// 		};

// 		return getAsync(ajaxArgs);
// 	},

// 	async save(data) {
	// 		console.log('RAW: ' + JSON.stringify(data));
	// 		// ----- This fails because PostalCode: {} "["
	// 		// ----- Postal code must be passed as string or api post will fail.
	// 		if (data.PostalCode === '[' || typeof data.PostalCode === 'object') {
	// 			data.PostalCode = '';
	// 			// console.log(JSON.stringify(data.PostalCode)); // -- This works
	// 		}
// 		data = JSON.stringify(data);

// 		const ajaxArgs = {
// 			url: apiProfile.url,
// 			data,
// 			type: 'post',
// 			dataType: 'json',
// 			headers: {
// 				'Content-Type': 'application/json',
// 				'x-api-key': apiProfile.apiKey
// 			}
// 		};

// 		return getAsync(ajaxArgs);
// 	}
// };

const apiLocation = {
	url: 'https://maps.googleapis.com/maps/api/geocode/json',
	apiKey: '', //getGooAPIkey(), // ----- gc-personalizer.js

	async fetch(address) {
		// address = encodeURI(address).replace(/%20/g, '+');

		try {
			const url = `${apiLocation.url}?address=${address}&key=${apiLocation.apiKey}`;
			const response = await fetch(url);

			if (!response.ok) {
				throw new Error(response.statusText);
			}
			return response.json();

		} catch (err) {
			console.error(`Cannot fetch location data - ${err}`);
		}
	},

	async fetchIp() {
		try {
			const response = await fetch('https://api.ipify.org/');

			if (!response.ok) {
				throw new Error(response.statusText);
			}

			return response.text();

		} catch (err) {
			console.error(`Cannot lookup ip - ${err}`);
		}
	},

	async fetchByIp() {
		try {
			const response = await fetch('https://freegeoip.net/json/');
			// ----- This URL is no longer in service.
			// ----- Instead use http://api.ipstack.com/186.116.207.169?access_key=398658c6cc034171df981949d2127d94&output=json&legacy=1
			// ----- Get payed version to get https support.
			// ----- Since this is not used anywhere we don't change it.
			// ----- If we do need this use the google geo api.
			if (!response.ok) {
				throw new Error(response.statusText);
			}

			return response.json();

		} catch (err) {
			console.error(`Cannot fetch location data - ${err}`);
		}
	}
};

const apiOrganizations = {
	async fetchTrending(state) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_trending',
				nonce: ajaxVars.nonce,
				api: 'organization',
				state
			}
		};

		return getAsync(ajaxArgs);
	},

	async fetchRelated(args) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_related_orgs',
				nonce: ajaxVars.nonce,
				args,
				state: geoloc.getState()
			}
		};

		return getAsync(ajaxArgs);
	},

	async fetchSearchResults(args) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_org_search_results',
				nonce: ajaxVars.nonce,
				args,
				state: geoloc.getState()
			}
		};

		return getAsync(ajaxArgs);
	}
};

const apiProjects = {
	async fetchTrending(state) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_trending',
				nonce: ajaxVars.nonce,
				api: 'project',
				state
			}
		};

		return getAsync(ajaxArgs);
	},

	async fetchRelated(args) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_related_projects',
				nonce: ajaxVars.nonce,
				args
			}
		};

		return getAsync(ajaxArgs);
	},

	async fetchSearchResults(args) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_project_search_results',
				nonce: ajaxVars.nonce,
				args
			}
		};

		return getAsync(ajaxArgs);
	}
};

const apiVolunteering = {
	async fetchRelated(args, location) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_related_volunteering',
				nonce: ajaxVars.nonce,
				args,
				location
			}
		};

		return getAsync(ajaxArgs);
	},

	async fetchSearchResults(args, location) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_volunteer_search_results',
				nonce: ajaxVars.nonce,
				args,
				location
			}
		};

		return getAsync(ajaxArgs);
	}
};

const apiSurvey = {
	url: 'https://ol73dde4x1.execute-api.us-west-2.amazonaws.com/dev/',
	apiKey: 'H1kQyXDxHS8oK0T2WpWd88r40zQYrNay8tfqS7RH',

	async save(data) {
		data = JSON.stringify(data);

		const ajaxArgs = {
			url: apiSurvey.url + `?SiteId=${SITE_ID}`,
			data,
			type: 'post',
			dataType: 'json',
			headers: {
				'Content-Type': 'application/json',
				'x-api-key': apiSurvey.apiKey,
				'crossOrigin': true
			}
		};

		return getAsync(ajaxArgs);
	}
};

const wpEvents = {
	async fetchRelated(args) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_related_events',
				nonce: ajaxVars.nonce,
				args
			}
		};

		return getAsync(ajaxArgs);
	}
};

const wpFunds = {
	async fetchTrending(state) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_trending',
				nonce: ajaxVars.nonce,
				api: 'fund',
				state
			}
		};

		return getAsync(ajaxArgs);
	},

	async fetchRelated(args) {
		const ajaxArgs = {
			type: 'get',
			dataType: 'html',
			url: ajaxVars.url,
			data: {
				action: 'gc_load_related_funds',
				nonce: ajaxVars.nonce,
				args
			}
		};

		return getAsync(ajaxArgs);
	}
};

const userProfile = {
	_data: {
		EmailAddress: '',
		SiteId: SITE_ID,
		UserName: '',
		FirstName: '',
		LastName: '',
		PhoneNumber: '',
		PostalCode: '',
		Sites: [
			{
				SiteID: SITE_ID,
				Tags: [],
				SavedPages: []
			}
		],
		ExperienceLevel: EXP_LEVEL_NONE,
		Newsletter: false,
		SMS: false
	},

	cacheExpiration: Date.now() + (60 * 1000 * 5), // 5 minutes

	set(key, value) {
		this._data[key] = value;
	},

	get(key) {
		return this._data[key];
	},

	getSiteData() {
		const sites = this._data.Sites;

		for (let i = 0, j = sites.length; i < j; i++) {
			if (sites[i].SiteID === SITE_ID) {
				return sites[i];
			}
		}

		return false;
	},

  //=================================
  //----- GC-PERSONALIZER ADD ON ----
  //=================================
  // ----- This is now handled by personalizer.js

	// getPages() {
	// 	const site = userProfile.getSiteData();

	// 	if (site && site.SavedPages) {
	// 		return site.SavedPages.map(Number);
	// 	}

	// 	return [];
	// },

	// setPages(pages) {
	// 	const site = userProfile.getSiteData();

	// 	if (site) {
	// 		site.SavedPages = pages;
	// 	}
	// },

	// addPage(id) {
	// 	const pages = userProfile.getPages();
	// 	pages.push(id);

	// 	// Merge 'em
	// 	userProfile.mergePages(pages);
	// },

	// removePage(id) {
	// 	const pages = userProfile.getPages();
	// 	const index = pages.indexOf(parseInt(id, 10));

	// 	if (index !== -1) {
	// 		pages.splice(index, 1);
	// 	}

	// 	userProfile.setPages(pages);
	// },

	// mergePages(pages) {
	// 	const userPages = userProfile.getPages();
	// 	pages = userPages.concat(pages);

	// 	const uniquePages = pages.reduce((p, c) => {
	// 		if (p.indexOf(c) === -1) {
	// 			p.push(c);
	// 		}

	// 		return p;
	// 	}, []);

	// 	userProfile.setPages(uniquePages);
	// },

	// getTags() {
	// 	const site = userProfile.getSiteData();

	// 	if (site && site.Tags) {
	// 		return site.Tags.map(Number);
	// 	}

	// 	return [];
	// },

	// setTags(tags) {
	// 	const site = userProfile.getSiteData();

	// 	if (site) {
	// 		site.Tags = tags;
	// 	}
	// },

	// addTag(id) {
	// 	const tags = userProfile.getTags();
	// 	tags.push(id);

	// 	// Merge 'em
	// 	userProfile.mergeTags(tags);
	// },

	// removeTag(id) {
	// 	const tags = userProfile.getTags();
	// 	const index = tags.indexOf(parseInt(id, 10));

	// 	if (index !== -1) {
	// 		tags.splice(index, 1);
	// 	}

	// 	userProfile.setTags(tags);
	// },

	// mergeTags(tags) {
	// 	const userTags = userProfile.getTags();
	// 	tags = userTags.concat(tags);

	// 	const uniqueTags = tags.reduce((p, c) => {
	// 		if (p.indexOf(c) === -1) {
	// 			p.push(c);
	// 		}

	// 		return p;
	// 	}, []);

	// 	userProfile.setTags(uniqueTags);
	// },

	async load(email) {
    const deferred = $.Deferred();

    //=================================
    //----- GC-PERSONALIZER ADD ON ----
    //=================================
    // ----- We no longer use the store for profile data
		// let storeProfile = store.get('userProfile');

		// // Verify cache profile matches the current user and site
		// if (storeProfile && email) {
		// 	if (storeProfile.EmailAddress !== email || storeProfile.SiteId !== SITE_ID) {
		// 		store.remove('userProfile');
		// 		storeProfile = null;
		// 	}
		// }

		// if (storeProfile) {
		// 	this._data = storeProfile;
		// 	deferred.resolve();

    // } else
    if (email) {
			apiProfile.fetch(email).then(data => {
				if (data) {
          // store.set('userProfile', data, userProfile.cacheExpiration);
					userProfile._data = data;

					deferred.resolve();
				}

				deferred.reject();

			}).catch(err => {
				deferred.reject(err);
			});

		} else {
			deferred.reject();
		}

		return deferred.promise();
  // },
  }

  //=================================
  //----- GC-PERSONALIZER ADD ON ----
  //=================================
  // ----- We no longer use the store for profile data

	// async save(full) {
	// 	const deferred = $.Deferred();
	// 	const userEmail = userProfile.get('EmailAddress');

	// 	if (userEmail) {
	// 		apiProfile.save(this._data).then(data => {
	// 			store.set('userProfile', data, userProfile.cacheExpiration);

	// 			if (full) {
	// 				userProfile.saveToWordpress();
	// 			}

	// 			deferred.resolve();

	// 		}).catch(() => {
	// 			deferred.reject();
	// 		});

	// 	} else {
	// 		store.set('userProfile', this._data, userProfile.cacheExpiration);
	// 		deferred.resolve();
	// 	}

	// 	return deferred.promise();
	// },

	// async saveToWordpress() {
	// 	const data = {
	// 		FirstName: userProfile.get('FirstName'),
	// 		LastName: userProfile.get('LastName'),
	// 		EmailAddress: userProfile.get('EmailAddress'),
	// 		Newsletter: userProfile.get('Newsletter'),
	// 		action: 'gc_update_wp_user',
	// 		nonce: ajaxVars.nonce
	// 	};

	// 	$.ajax({
	// 		url: ajaxVars.url,
	// 		type: 'post',
	// 		data

	// 	}).catch(() => {
	// 		console.error('Cannot save to Wordpress');
	// 	});
	// }
};

const userLocation = {
	cacheExpiration: Date.now() + (60 * 1000 * 30), // 30 minutes

	async getIp() {
		// const ip = store.get('userIp');
		const ip = getStoredLocationData('userIP');

		if (ip) {
			return ip;
		}

		// return apiLocation.fetchIp();
	},

	async getLocation() {
		// let storeLocation = store.get('userLocation');
		// ----- Function in ge-personalizer to get wpData.
		let storeLocation = getStoredLocationData('userZIP');

		// console.log('Get Location: ' + JSON.stringify(storeLocation));
		// let userIP = getCurrentIP();
		// let userIP = getStoredLocationData('userIP');
		// console.log(userIP);
		// useGoogleMaps();
		// let locat = getLocationDtails();
		// console.log(locat);
		// let decip = convertIpToDecimal('66.170.189.242');
		// console.log(decip);
		let zip = 0;

		if (!storeLocation) {
			// ----- Check if we have a zip in local session storage.
			let userZIP = '';
			// ----- First check session sorage for current selection.
			let locationdata = JSON.parse(sessionStorage.getItem('location'));
			if (locationdata) {
				userZIP = parseGooData(locationdata, 'userZIP');
			}
			if (userZIP) {
				zip = userZIP;
			} else {
				zip = 98101;
			}

			// ----- This is not used
			// ----- freegeoip.net is no longer in use
			// 	const data = await apiLocation.fetchByIp();

			// 	if (data && data.zip_code) {
			// 		zip = data.zip_code;

			// 	} else {
			// 		throw new Error('No location data.');
			// 	}

			// } catch (err) {
			// 	if (typeof wpUser !== 'undefined') {
			// 		zip = userProfile.get('PostalCode');
			// 	}
			// }
		} else {
			zip = storeLocation;
		}

		if (zip) {
			try {
				const KEY = 'userLocation_' + zip;
				let data = {};
				let storedApiResponse = store.get(KEY);

				if (storedApiResponse && Object.keys(storedApiResponse).length > 0) {
					data = storedApiResponse;
				} else {
					data = await apiLocation.fetch(zip);
					store.set(KEY, data, userLocation.cacheExpiration);
				}

				if (data) {
					// console.log(JSON.stringify(data));
					storeLocation = data.results[0];

				} else {
					throw new Error('Cannot get location data.');
				}

			} catch (err) {
				console.error(err);
			}
		}

		return storeLocation;
	},

	async getLatLng() {
		const address = await userLocation.getLocation();

		if (address) {
			return address.geometry.location;
		}

		return {
			lat: 47.6015566,
			lng: -122.3323351
		};
	},

	async getCity(long) {
		const city = await userLocation.parseAddress(['locality', 'sublocality']);

		if (city) {
			return long ? city.long_name : city.short_name;
		}

		return 'Seattle';
	},

	async getState(long) {
		const state = await userLocation.parseAddress('administrative_area_level_1');

		if (state) {
			return long ? state.long_name : state.short_name;
		}

		return long ? 'Washington' : 'WA';
	},

	async getPostalCode(fallback) {
		const zip = await userLocation.parseAddress('postal_code');

		if (zip) {
			return zip.short_name;
		}

		return fallback ? 98103 : false;
	},

	async parseAddress(type) {
		const typeArr = Array.isArray(type) ? type : [type];
		let address = await userLocation.getLocation();
		// let address = '90402';
		let ret = false;

		if (address) {
			address = address.address_components;
			// console.log(JSON.stringify(address));
			typeArr.forEach(type => {
				for (let i = 0, j = address.length; i < j; i++) {
					const types = address[i].types;

					if (types.indexOf(type) !== -1) {
						ret = address[i];
					}
				}
			});
		}

		return ret;
	},

	async init() {
		const storeLocation = store.get('userLocation');
		if (storeLocation) {
			userLocation.update();

		} else {
			const data = await userLocation.getLocation();
			if (data) {
				userLocation.save(data);

			} else {
				// userLocation.update();
				//----- We get this from DB and insert directly in case we can not connect to google.maps
				let city = getStoredLocationData('userCity')
				let state = getStoredLocationData('userStateShort');
				// console.log(JSON.stringify(city));
				if (state) {
					$('.location-status').html(`${city}, ${state}`);
					$('.nav-location .fade').addClass('show');
				} else {
					userLocation.update();
				}
			}
		}
	},

	async update() {
		const city = await userLocation.getCity();
		const state = await userLocation.getState();

		$('.location-status').html(`${city}, ${state}`);
		$('.nav-location .fade').addClass('show');

		if (typeof FWP !== 'undefined' && typeof FWP_HTTP !== 'undefined') {
			const coords = await userLocation.getLatLng();

			FWP_HTTP.coords = coords;
			FWP.refresh();
		}
	},

	save(data) {
		store.set('userLocation', data, userLocation.cacheExpiration);
		userLocation.update();
	}
};

const userSurvey = {
	_data: {
		Id: null,
		EmailAddress: '',
		Donated: null,
		DonateAgain: null,
		Like: null,
		Funded: null,
		FundAgain: null
	},

	get(key) {
		return this._data[key];
	},

	set(key, value) {
		this._data[key] = value;
	},

	async save() {
		let email = userProfile.get('EmailAddress');

		if (!email) {
			email = await userLocation.getIp();
		}

		$.extend(this._data, {
			EmailAddress: email
		});

		return apiSurvey.save(this._data).then(response => {
			userSurvey._data = response.SocialData;

		}).catch(() => {
			console.log('Cannot save user survey');
		});
	}
};

const injectContent = {
	_el: document.querySelectorAll('[data-inject]'),

	async init() {
		if (this._el.length) {
			[].forEach.call(this._el, async el => {
				const args = JSON.parse(el.getAttribute('data-args'));
				const context = el.getAttribute('data-inject');
				let zip = await geoloc.getZip();
				let _promise;

				// Fallback if zip code fails, we will get the state
				zip = zip || await userLocation.getState();
				// console.log(zip);

				switch (context) {
					case 'search': {
						const api = args.api;

						if (api === 'organizations') {
							_promise = apiOrganizations.fetchSearchResults(args);

						} else if (api === 'projects') {
							_promise = apiProjects.fetchSearchResults(args);

						} else if (api === 'volunteering') {
							_promise = apiVolunteering.fetchSearchResults(args, zip);
						}

						break;
					}

					case 'related-widget': {
						const api = args.api;

						if (api === 'organizations') {
							_promise = apiOrganizations.fetchRelated(args);

						} else if (api === 'projects') {
							_promise = apiProjects.fetchRelated(args);

						} else if (api === 'volunteering') {
							_promise = apiVolunteering.fetchRelated(args, zip);

						} else if (api === 'funds') {
							_promise = wpFunds.fetchRelated(args);

						} else if (api === 'events') {
							_promise = wpEvents.fetchRelated(args);
						}

						break;
					}

					case 'connect': {
						const ajaxArgs = {
							type: 'get',
							dataType: 'html',
							url: ajaxVars.url,
							data: {
								action: 'gc_load_connect_content',
								nonce: ajaxVars.nonce,
								location: zip,
								args
							}
						};

						_promise = getAsync(ajaxArgs);

						break;
					}

					case 'take-action': {
						const ajaxArgs = {
							type: 'get',
							dataType: 'html',
							url: ajaxVars.url,
							data: {
								action: 'gc_load_action_content',
								nonce: ajaxVars.nonce,
								location: zip,
								args
							}
						};

						_promise = getAsync(ajaxArgs);

						break;
					}

					default: break;
				}

				if (_promise) {
					_promise.then(response => {
						el.innerHTML = response;

						const shaveElements = el.querySelectorAll('.shave');

						[].forEach.call(shaveElements, shaveEl => {
							shaveLines(shaveEl);
						});

						eqcol(document.querySelectorAll('[data-eqcol]'));

					}).catch(err => {
						console.error(err)
					});
				}
			});
		}
	}
};

const apiWidgets = {
	async loadTrending() {
    const userState = geoloc.getState();

		$('.widget-tabs-content[data-api-method="trending"]').each(function () {
			const $this = $(this);
			const api = $this.data('api');

			switch (api) {
				case 'organization':
					apiOrganizations.fetchTrending(userState).then(response => {
						$this.html(response);

					}).catch(() => {
						$this.html('<p class="text-center">We\'re currently crunching the numbers.</p>');
					});

					break;

				case 'project':
					apiProjects.fetchTrending(userState).then(response => {
						$this.html(response);

					}).catch(() => {
						$this.html('<p class="text-center">We\'re currently crunching the numbers.</p>');
					});

					break;

				case 'fund':
					wpFunds.fetchTrending(userState).then(response => {
						$this.html(response);

					}).catch(() => {
						$this.html('<p class="text-center">We\'re currently crunching the numbers.</p>');
					});

					break;

				default: break;
			}
		});
	}
};

function shaveLines(element) {
	const $this = $(element);
	const original = $this.css('white-space');
	const height = parseFloat($this.css('white-space', 'nowrap').outerHeight());
	const lines = $this.data('lines') || 2;

	// Reset white-space
	$this.css('white-space', original);

	if (isNaN(height) || height === 0) {
		$this.addClass('shaved'); // If error, display
		return;
	}

	// Wait to make sure white-space is set then shaaavvveee
	setTimeout(() => {
		shave(element, (height * lines));
		$this.addClass('shaved');
	}, 0);
}

$(document).on('facetwp-loaded', async () => {
  // var $totCat;
	// Hide empty facets
	// $.each(FWP.settings.num_choices, (key, val) => {
	// 	const $parent = $('.facetwp-facet-' + key).closest('.widget-wrapper');

	// 	if (val === 0) {
	// 		$parent.hide();

	// 	} else {
	// 		$parent.show();
	// 	}
  // });
  //=================================
  //----- GC-PERSONALIZER ADD ON ----
  //=================================
  // $totCat = _.sum(_.values(FWP.settings.num_choices));

  // ----- Replace lodash with vanilla js because this is the only place lodash is used.
  function setUsers(data) {
    var total = 0;
    for (var k in data) {
        if (data.hasOwnProperty(k)) {
           // user[k] = data[k];
           // console.log(JSON.stringify(data[k]));
           total += data[k];
        }
    }
    return total;
  }
  var $totCat = setUsers(FWP.settings.num_choices);
  // console.log($totCat);
  // ---------------------------------------------

  $.each(FWP.settings.num_choices, function (key, val) {
    // console.log(JSON.stringify(FWP.settings.num_choices));
    // {"categories":0,"event_dates":0,"online_events":0,"event_radius":0}
    var $parent = $('.facetwp-facet-' + key).closest('.widget-wrapper');
    // ----- If all values are 0 the menu gets messed up.
    // ----- So prevent that by passing at least one value error message
    if ($totCat === 0 && key === 'categories') {
      $parent = $('.facetwp-facet-' + key).closest('.widget-wrapper').html('<p>No refinements available.</p>');
      val = 1;
    }
    if (val === 0) {
      $parent.hide();
    } else {
      $parent.show();
    }
  });

	// Shave titles
	$('.facetwp-template').find('.shave').each(function () {
		shaveLines(this);
	});

	// Update result count
	// if (!FWP.is_api) {
	// 	const total = FWP.settings.pager.total_rows;
	// 	const wording = total === 1 ? 'result' : 'results';
	//
	// 	$('[data-id="result-count"]').text(`${total} ${wording}`);
	// }

}).on('awesomplete-open', '.typeahead', function () {
	$(this).addClass('active');

}).on('awesomplete-close', '.typeahead', function () {
	$(this).removeClass('active');

}).on('click', '[data-join]', e => {
	const $modal = $('.modal');

	e.preventDefault();

	// Bring to front first
	$modal.addClass('show');

	setTimeout(() => {
		$modal.addClass('in');
	}, 0);

}).on('click', '.modal', e => {
	if (e.target === e.currentTarget) {
		$(e.target).find('.close[data-dismiss]').trigger('click');
	}

}).on('click', 'button[data-dismiss=".modal"]', () => {
	let $activeModal = $('.modal, .show');

	if ($activeModal.length) {
		$activeModal.removeClass('show');
	}


}).on('keydown', function (e) {
	if (e.keyCode === 27) {
		const $modal = $(this).find('.modal');

		if ($modal.hasClass('.in')) {
			$modal.find('.close[data-dismiss]').trigger('click');
		}
	}
//=================================
//----- GC-PERSONALIZER ADD ON ----
//=================================
// }).on('click', '[data-api-action]', function (e) {
// 	const $this = $(this);
// 	const api = $this.data('api');
// 	const action = $this.data('api-action');

// 	e.preventDefault();

// 	switch (api) {
// 		case 'profile': {
// 			let id;

// 			if (action === 'follow') {
// 				id = $this.data('category-id');

// 				userProfile.addTag(id);
// 				userProfile.save().then(() => {
// 					$this.data('api-action', 'unfollow')
// 						.text('Following')
// 						.blur();

// 				}).catch(() => {
// 					userProfile.removeTag(id);
// 				});

// 			} else if (action === 'unfollow') {
// 				id = $this.data('category-id');

// 				userProfile.removeTag(id);
// 				userProfile.save().then(() => {
// 					$this.data('api-action', 'follow')
// 						.text('Follow')
// 						.blur();

// 				}).catch(() => {
// 					userProfile.addTag(id);
// 				});

// 			} else if (action === 'save') {
// 				const isSaved = Boolean($this.data('postSaved'));
// 				id = $this.data('postId');

// 				if (isSaved) {
// 					userProfile.removePage(id);

// 				} else {
// 					userProfile.addPage(id);
// 				}

// 				$this.toggleClass('is-saved', !isSaved).data('postSaved', !isSaved);

// 				userProfile.save().catch(() => {
// 					$this.toggleClass('is-saved', isSaved).data('postSaved', isSaved);

// 					// Revert changes to local profile
// 					if (isSaved) {
// 						userProfile.addPage(id);

// 					} else {
// 						userProfile.removePage(id);
// 					}
// 				});
// 			}

// 			break;
// 		}
// 		default: break;
// 	}

}).on('click', '.close[data-dismiss]', function (e) {
	const $this = $(this);
	const target = $this.data('dismiss');
	const $target = $(target);

	e.preventDefault();

	if ($target.length) {
		$target.removeClass('in').one('transitionend', () => {

			if ($target.is('.modal')) {
				$target.removeClass('show');

			} else {
				$target.remove();
			}

			// Save preference in session
			const action = $this.data('action');

			if (action) {
				store.set(action, true);
			}
		});
	}

}).on('click', '.post-feature-share-link', function (e) {
	e.preventDefault();
	const $this = $(this);
	const parent = $this.parents('.standard-social');
	$this.toggleClass('active');
	const target = parent.children('.featured-share-links');
	target.slideToggle(250);
})
.on('click', '.post-share-link', function (e) {
	const $this = $(this);
	const parent = $this.closest('.standard-social');
	const mql = window.matchMedia('(min-width: 479px)');

	if (!parent.length || (parent.length && mql.matches)) {
		e.preventDefault();

		$this.toggleClass('active');
		$this.closest('ul').next().slideToggle(230);

	} else {
		const url = $this.closest('.standard-post-image').find('a.penci-image-holder').attr('href');

		// Redirect
		window.location.href = url;
	}

//=================================
//----- GC-PERSONALIZER ADD ON ----
//=================================
// }).on('click', '.saved-stories input[type="checkbox"]', function () {
// 	const $trash = $('#saved-stories-trash');

// 	if (this.checked) {
// 		$trash.addClass('in');

// 	} else {
// 		const checkboxes = $(this).closest('.saved-stories').find('input[type="checkbox"]:checked');

// 		if (checkboxes.length === 0) {
// 			$trash.removeClass('in');
// 		}
// 	}

}).on('click', '.link-more', function (e) {
	const target = $(this).data('target');
	const $target = $(target);

	e.preventDefault();

	if ($target.length) {
		$target.slideToggle(230);
	}

}).on('click', '[for="mobile-nav-search"], [for="mobile-nav-menu"]', () => {
	$(document.body).toggleClass('no-scroll');

}).on('click', '.home-nav-blade a, .home-primary-chevron a', e => {
	const target = e.currentTarget.hash;
	const top = $(target).offset().top - 75;

	$('html, body').animate({
		scrollTop: top
    }, 500);

}).on('click', '.penci-post-like', function (e) {
	const $this = $(this);
	const postId = $this.data('post_id');
	let $selector = $this.children('.dt-share');
	let count = parseInt($this.data('like-count'), 10);
	let likeWording = 'likes';

	e.preventDefault();

	if ($this.hasClass('single-like-button')) {
		$selector = $this.parent().find('.count-number-like');
	}

	const $wordSelector = $selector.siblings('.count-wording');
	const hasWording = $wordSelector.length || false;

	if ($this.hasClass('liked')) {
		count--;

		$this.removeClass('liked');
		$this.prop('title', 'Like');
		$this.data('like-count', count);

		$selector.text(count);

		if (hasWording) {
			if (count === 1) {
				likeWording = 'like';
			}

			$wordSelector.text(likeWording);
		}

	} else {
		count++;

		$this.addClass('liked');
		$this.prop('title', 'Unlike');
		$this.data('like-count', count);

		$selector.text(count);

		if (hasWording) {
			if (count === 1) {
				likeWording = 'like';
			}

			$wordSelector.text(likeWording);
		}
	}

	jQuery.ajax({
		type: 'post',
		url: ajaxVars.url,
		data: `action=penci-post-like&nonce=${ajaxVars.nonce}&penci_post_like=&post_id=${postId}`
	});

}).on('click', '.tabs label', function () {
	const $this = $(this);

	if (!$this.is('.active')) {
		$this.closest('.tabs').find('label').removeClass('active');
		$this.addClass('active');
	}

});

function handleZipcodeChange (e) {
	const $this = $(this);
	const target = $this.data('target');
	const $target = $(target);

	e.preventDefault();

	if ($target.length) {
		if ($this.is('input') && $target.is('.active')) {
			return;
		}

		$target.toggleClass('show').one('transitionend', () => {
			if ($target.hasClass('show')) {
				$target.addClass('active').find('input').focus();

				$(document).on('click.menu', e => {
					const $doctarget = $(e.target);
					const _target = $doctarget.data('target');

					if (!$doctarget.closest('.togglable').length && _target !== target) {
						$target.removeClass('active show');
						$(e.delegateTarget).off('click.menu');
					}
				});
			}
		});

		if (!$target.hasClass('show')) {
			$target.removeClass('active');
		}
	}

};

$('#nav-location').on('click', handleZipcodeChange);

$('#nav-location-mobile').on('click', handleZipcodeChange);

// Manual newsletter subscribe

function handleHomePageNewsletterSubscribe(e) {
	e.preventDefault();
	var $form = $('#stay-informed form.mc4wp-form');
	var $email = $form.find('input[name=EMAIL]').val();
	$.ajax(
		{
			type: 'post',
			url: '/api/newsletter/subscribe',
			data: {
				email: $email,
				tag: 'homepage',
			}
		}
	).then((res)=>{
		let $successMsg = 'Thank you, your sign-up request was successful! Please check your email inbox to confirm.';
		$form.html(`<div class="mc4wp-response"><div class="mc4wp-alert mc4wp-success"><p>${$successMsg}</p></div></div>`);
	}).catch((err)=> {
		let $errMsg = 'Oops. Something went wrong. Please try again later.';
		
		if (err.status === 422) {
			$errMsg = Object.values(err.responseJSON.errors)[0] || $errMsg;
		} 

		$('#stay-informed .mc4wp-response').html(`<div class="mc4wp-alert mc4wp-error"><p>${$errMsg}</p></div>`);
	})
	
};

$('#stay-informed form.mc4wp-form').on('submit', handleHomePageNewsletterSubscribe);

//=================================
//----- GC-PERSONALIZER ADD ON ----
//=================================
//----- modify

// User location custom input field

async function submitZipcodeUpdate(e) {
	e.preventDefault();
	const $form = $(this);
	let input = $form.find('input').val();
	input = input.trim();

	if (input) {
		try {
			const geoLocation = await geoloc.getGeoLocationByPostal(input);
			geoloc.saveLocationProfile(geoLocation);
			geoloc.htmlUpdateLocation(geoLocation);
		} finally {
			apiWidgets.loadTrending();
			const toggleId = $form.siblings('a').attr('id');
			$(`#${toggleId}`).trigger('click');
		}
	}
};

$('#nav-location-input').on('submit', submitZipcodeUpdate);

$('#nav-location-input-mobile').on('submit', submitZipcodeUpdate);

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

// If the SMS opt-in changes, make sure we update the phone requirement as well
$('#opt-sms').on('change', function () {
	const phoneInput = $(this).closest('form').find('input[name="PhoneNumber"]');

	if (phoneInput.length) {
		phoneInput.prop('required', this.checked);
	}
});

$('#join-info').on('click', 'button[data-toggle]', function (e) {
	const $this = $(this);
	const $container = $(e.delegateTarget);
	const $fields = $this.closest('.fade').find('input[required]:visible');

	e.preventDefault();

	// Validate required fields
	if ($fields.length !== 0) {
		$fields.each(function () {
			$(this).toggleClass('required', this.value.trim().length === 0);
		});

		if ($fields.hasClass('required')) {
			return false;
		}
	}

	const nextId = $this.data('toggle');
	const $next = $(nextId);

	if ($next.length !== 0) {
		$(this).parent().parent().removeClass('in').on('transitionend', function () {
			$(this).addClass('hidden');
			$next.removeClass('hidden');

			setTimeout(() => {
				$next.addClass('in');
			}, 0);
		});
	}

	// Set values to temp profile object
	$container.find('input').each(function () {
		let value = this.value;

		if ($(this).is(':checkbox')) {
			value = this.checked;
		}

		userProfile.set(this.name, value);
	});

	// Get and save zip to profile, too
	let zip = userProfile.get('PostalCode');

	if (!zip) {
		zip = geoloc.getZip();

		if (zip) {
			userProfile.set('PostalCode', zip);
		}
	}

	userProfile.save(true);
});

//=================================
//----- GC-PERSONALIZER ADD ON ----
//=================================
// $('#saved-stories-edit').on('click', function (e) {
// 	const $this = $(this);
// 	const $grid = $('.saved-stories');
// 	const isEditing = !$this.data('isEditing');

// 	e.preventDefault();

// 	$grid.find('.saved-post-edit').slideToggle(230);

// 	// If they finished editing...
// 	if (!isEditing) {
// 		$('#saved-stories-trash').removeClass('in');
// 		$grid.find('input[type="checkbox"]:checked').prop('checked', '');
// 	}

// 	// Save edit mode
// 	$this.data('isEditing', isEditing)
// 		.text(isEditing ? 'Done' : 'Edit')
// 		.blur();
// });

// $('#saved-stories-trash').on('click', function (e) {
// 	const $this = $(this);
// 	const $grid = $('.saved-stories');
// 	const items = [];

// 	e.preventDefault();

// 	$grid.find('.saved-post-edit input[type="checkbox"]:checked').each(function () {
// 		const item = $(this).closest('li');

// 		items.push(item);
// 		userProfile.removePage(this.value);
// 	});

// 	if (items.length) {
// 		const $alert = $('.alert');

// 		userProfile.save().then(() => {
// 			$.each(items, function () {
// 				const $that = $(this);

// 				$that.removeClass('in').one('transitionend', () => {
// 					$that.remove();
// 				});
// 			});

// 			$this.removeClass('in');

// 			// Show message
// 			$alert.removeClass('alert-error')
// 				.addClass('alert-success')
// 				.find('p')
// 				.text($alert.data('success'))
// 				.end()
// 				.slideDown(230);

// 		}).catch(() => {
// 			$.each(items, function () {
// 				const checkbox = $(this).find('.saved-post-edit input[type="checkbox"]').get(0);

// 				// Add back to profile as fallback
// 				userProfile.addPage(checkbox.value);
// 			});

// 			// Show message
// 			$alert.removeClass('alert-success')
// 				.addClass('alert-error')
// 				.find('p')
// 				.text($alert.data('error'))
// 				.end()
// 				.slideDown(230);
// 		});
// 	}
// });

$('.dropdown-toggle').dropdown();

$('.dropdown').not('#header .dropdown').on('click', '> ul li', function (e) {
	const $this = $(this);
	const $drop = $(e.delegateTarget);
	const value = $this.data('value');
	const selectedText = $this.text();

	$drop.find('input:checkbox').val(value);
	$drop.find('.dropdown-toggle').text(selectedText);

	if ($this.parent().is(':visible')) {
		$drop.find('.dropdown-toggle').trigger('click');
	}

	if (value !== 0) {
		$drop.removeClass('required');
	}

}).on('change', 'input:checkbox', function () {
	const $doc = $(document);

	if (this.checked) {
		const $this = $(this);

		$doc.on('click.dd', e => {
			if (!$(e.target).closest('.dropdown').length) {
				$this.prop('checked', '');
				$doc.off('click.dd');
			}
		});

	} else {
		$doc.off('click.dd');
	}
});

$('.accordian').on('click', '> label', e => {
	const accordian = $(e.delegateTarget);

	e.preventDefault();

	accordian.toggleClass('open').find('.accordian-inner').slideToggle(230)
		.end().siblings().removeClass('open').find('.accordian-inner').slideUp();

}).on('click', '.select-all', function () {
	const that = this;
	const input = $(that).siblings('input').get(0);
	let options;
	let _input;

	// This is checked before the click event fires
	if (input.checked) {
		options = $(that).closest('ul').next().find('label').filter(function () {
			_input = $(this).siblings('input').get(0);

			if (_input.checked) {
				return true;
			}

			return false;
		});

	} else {
		options = $(that).closest('ul').next().find('label').filter(function () {
			_input = $(this).siblings('input').get(0);

			if (!_input.checked) {
				return true;
			}

			return false;
		});
	}

	if (options.length !== 0) {
		options.each(function () {
			$(this).click();
		});
	}
});

//=================================
//----- GC-PERSONALIZER ADD ON ----
//=================================
// Personalize action of join process
// $('.form-register').on('click', 'button.submit:not(.disabled)', function (e) {
// 	const $this = $(this);
// 	const $form = $(e.delegateTarget);
// 	const $drop = $('#dd-level');
// 	const $alert = $form.find('.alert');
// 	const level = parseInt($drop.val(), 10);

// 	e.preventDefault();

// 	// Set values to temp profile object
// 	$form.find('input').each(function () {
// 		let value = this.value;

// 		if ($(this).is(':checkbox')) {
// 			value = this.checked;
// 		}

// 		userProfile.set(this.name, value);
// 	});

// 	// Require the Experience Level to be chosen
// 	if (level === 0) {
// 		const msg = $alert.data('msg');

// 		$drop.closest('.dropdown').addClass('required');
// 		$alert.removeClass('hidden').find('p').text(msg);

// 		$('html, body').animate({
// 			scrollTop: '0px'
// 		});

// 		return false;
// 	}

// 	// Grab the selected interests
// 	const interests = [];

// 	$form.find('.accordian input[type="checkbox"]:not(.chk-all):checked').each(function () {
// 		interests.push(this.value);
// 	});

// 	userProfile.set('ExperienceLevel', level);
// 	userProfile.setTags(interests);

// 	// Disable button
// 	$this.addClass('disabled');

// 	// Clear message
// 	$alert.addClass('hidden');

// 	// Save to profile api
// 	userProfile.save().then(() => {
// 		$form.submit();

// 	}).catch(() => {
// 		$this.removeClass('disabled');
// 	});
// });

$('.survey-questions').on('change', 'input:radio', function () {
	const $this = $(this);
	const $form = $this.closest('form');
	const name = $this.attr('name');
	const value = Boolean($this.val());

	if (name === 'Donated' || name === 'Funded') {
		setTimeout(() => {
			$this.closest('li').removeClass('in').one('transitionend', function () {
				const $that = $(this);
				const $next = value === true ? $that.next() : $that.siblings(':last');

				$that.addClass('hidden');
				$next.removeClass('hidden');

				setTimeout(() => {
					$next.addClass('in');
				}, 0);

				if (!value) {
					setTimeout(() => {
						$form.removeClass('in').one('transitionend', () => {
							$form.slideUp();
						});
					}, 3000);
				}
			});
		}, 700);

	} else {
		setTimeout(() => {
			$this.closest('li').removeClass('in').one('transitionend', function () {
				const $that = $(this);
				$that.addClass('hidden');

				const $next = $that.next();
				$next.removeClass('hidden');

				setTimeout(() => {
					$next.addClass('in');

					// Hide entire survey banner
					setTimeout(() => {
						$form.removeClass('in').one('transitionend', () => {
							$form.slideUp();
						});
					}, 3000);
				}, 0);
			});
		}, 700);
	}

	const unindexed = $form.serializeArray();
	const indexed = {};

	$.map(unindexed, n => {
		indexed[n.name] = n.value;
	});

	$.extend(userSurvey._data, indexed);
	userSurvey.save();
});

$(() => {
	const userEmail = typeof wpUser === 'undefined' ? null : wpUser.EmailAddress;

	// Get user's location first, then load relative data
	geoloc.init().then(() => {
		apiWidgets.loadTrending();
		injectContent.init();
	});

  //=================================
  //----- GC-PERSONALIZER ADD ON ----
  //=================================
	// Load the user's profile information, if available
	userProfile.load(userEmail).then(() => {
		// Check for the user's Saved Stories and then activate the
		// button/link action on each post
    // var pages = userProfile.getPages();
		// const pages = userProfile.getPages();

		// if (pages.length) {
		// 	$('.save-story').each(function () {
		// 		const $this = $(this);
		// 		const postId = $this.data('postId');
		// 		const index = pages.indexOf(postId);

		// 		if (index !== -1) {
		// 			$this.addClass('is-saved').data('postSaved', true);
		// 		}
		// 	});
		// }

	}).then(() => {
		// Display user's preference settings (faster than PHP lookup)

		// $('[data-api-profile]').each(function () {
		// 	const $this = $(this);
		// 	const type = $this.data('api-profile');

		// 	switch (type) {
		// 		case 'experience': {
		// 			const level = userProfile.get('ExperienceLevel');
		// 			$this.find('li').filter('[data-value="' + level + '"]').trigger('click');

		// 			break;
		// 		}
		// 		case 'interests': {
		// 			const interests = userProfile.getTags();

		// 			$this.find('input[type="checkbox"]:not(.chk-all)').each(function () {
		// 				const _this = $(this);
		// 				const value = _this.val();

		// 				if (interests.indexOf(value) !== -1) {
		// 					_this.prop('checked', true);
		// 				}
		// 			});

		// 			break;
		// 		}
		// 		default: break;

		// 	}
		// });

	}).catch(() => {
		// User is not logged in
	});

	// Do things on window resize
	$(window).on('resize', debounce(() => {
		$('.shave').each(function () {
			shaveLines(this);
		});

		// Equal columns
		eqcol(document.querySelectorAll('[data-eqcol]'));

	})).trigger('resize');

	// // Load search terms for typeahead
	// getAsync({
	// 	type: 'get',
	// 	dataType: 'json',
	// 	url: ajaxVars.url,
	// 	data: {
	// 		action: 'gc_load_search_terms',
	// 		nonce: ajaxVars.nonce
	// 	}
	// }).then(response => {
	// 	// Initialize autocomplete on some search inputs
	// 	$('.typeahead').each((index, el) => {
	// 		const typeahead = new Awesomplete(el, {
	// 			minChars: 3,
	// 			maxItems: 6
	// 		});

	// 		// Set list index
	// 		typeahead.list = response.list;
	// 	});
  // });

  // ---------------------------------------------------------------------------
	// ----- Load search terms from .json file not using mysql -------------------
	// $.ajax({
	// 	type: 'post',
	// 	dataType: 'html',
	// 	url: 'https://' + window.location.hostname + '/wp-content/uploads/.json/relevanssi.json',
	// 	data: []

	//   }).then(function (data) {

	// 	// console.log(JSON.stringify(response));
	// 	// Initialize autocomplete on some search inputs
	// 	$('.typeahead').each(function (index, el) {
	// 	  var typeahead = new Awesomplete(el, {
	// 		minChars: 2,
	// 		maxItems: 8
	// 	  });
	// 	  // console.log(data);
	// 	  // Set list index
	// 	  typeahead.list = data;
	// 	});
	//   }).catch(function (err) {
	// 	console.error(err);
	// });

	// Setup compass orientation and positioning
	$('.compass__container').each((index, el) => {
		const compassPoints = el.querySelectorAll('.compass__point');

		for (let i = 0; i < compassPoints.length; i++) {
			const x = (35 - (35 * Math.cos((-0.5 * Math.PI) - (2 * (1 / compassPoints.length) * i * Math.PI))));
			const y = (40 + (40 * Math.sin((-0.5 * Math.PI) - (2 * (1 / compassPoints.length) * i * Math.PI))));

			compassPoints[i].style.left = `${x}%`;
			compassPoints[i].style.top = `${y}%`;
		}
	});

	if (typeof FWP === 'undefined') {
		// Load content using Wordpress, no facets here

		$(document).on('click', '.penci-ajax-more-button', function (e) {
			const $this = $(this);

			if ($this.hasClass('loading-posts')) {
				return false;
			}

			e.preventDefault();

			const layout = $this.data('layout');
			const mes = $this.data('mes');
			const args = $this.data('args');
			let offset = $this.attr('data-offset');

			const data = {
				offset,
				layout,
				args,
				action: 'gc_more_post_ajax',
				nonce: ajaxVars.nonce
			};

			$this.addClass('loading-posts');

			$.ajax({
				type: 'post',
				dataType: 'html',
				url: ajaxVars.url,
				data

			}).then(data => {
				if (data) {
					let $element = $('.theiaStickySidebar');

					offset = parseInt(offset, 10) + args.posts_per_page;
					$this.attr('data-offset', offset);

					if (layout === 'standard' || layout === 'classic') {
						$element.find('> article:last').after(data);

					} else if (layout === 'overlay') {
						$element.find('> section:last').after(data);

					} else if (layout === 'masonry' || layout === 'masonry-2') {
						$element = $('.penci-masonry');

						$(data).imagesLoaded(() => {
							$element.isotope('insert', $(data));
						});

					} else {
						$element.find('> ul.penci-grid').append(data);
					}

					$this.removeClass('loading-posts');
					$element.find('.shave:not(.shaved)').each((index, el) => shaveLines(el));

				} else {
					$('.penci-ajax-more-button .ajax-more-text').text(mes);
					$('.penci-ajax-more-button i').remove();

					$this.removeClass('loading-posts');
					setTimeout(() => {
						$this.remove();
					}, 1200);
				}

			}).catch(err => {
				console.error(err);
			});
		});

	} else {
		// This page has facets, so we need to handle
		// loading more content differently

		if (FWP.is_api) {
			$('.penci-ajax-more-button').hide();
		}

		if (wp && wp.hooks) {
			wp.hooks.addFilter('facetwp/template_html', (response, params) => {
				if (FWP.is_load_more) {
					FWP.is_load_more = false; // eslint-disable-line camelcase
					$('.facetwp-template').append(params.html);

					return true;
				}

				return response;
			});

			userLocation.getLatLng().then(coords => {
				wp.hooks.addAction('facetwp/refresh/radius', () => {
					if (!FWP.loaded) {
						FWP_HTTP.coords = coords;
					}
				});
			});
		}

		$(document).on('facetwp-refresh', function () {
			if (!FWP.loaded) {
				FWP.paged = 1;

				$(this).on('click', '.penci-ajax-more-button', function (e) {
					e.preventDefault();

					// Show loading message
					$(this).addClass('loading-posts');

					FWP.is_load_more = true; // eslint-disable-line camelcase
					FWP.paged = parseInt(FWP.settings.pager.page, 10) + 1;
					FWP.soft_refresh = true; // eslint-disable-line camelcase
					FWP.refresh();
				});
			}

		}).on('facetwp-loaded', () => {
			if (FWP.settings.pager.page < FWP.settings.pager.total_pages) {
				if (FWP.loaded) {
					$('.penci-ajax-more-button').removeClass('loading-posts').show();
				}

			} else {
				$('.penci-ajax-more-button').hide();
			}

			if (FWP.loaded) {
				$('#main').find('.shave:not(.shaved)').each((index, el) => shaveLines(el));
			}
		});
	}
});

// Magazines page filters

$('button[data-filter="blank"]').addClass('btn-neutral-medium-outline-active');

	$('#magazine-filters').click(function (event) {
		var filter = event.target.dataset.filter;

		//remove active button state from all
		$('#magazine-filters button').removeClass('btn-neutral-medium-outline-active');

		//remove hidden class from all elements
		$('ul.partner-list li').removeClass('hidden');
		/*
		 Add alphabetical sort on topic magazine filtered view.
		 Added by kala.w @ Giving Tech Labs on 02/21/2018
	 */
		if (filter == 'topic_magazine') {
			$('button[data-filter="topic_magazine"]').addClass('btn-neutral-medium-outline-active');
			$('li[data-type="partner_page"]').addClass('hidden');
			var alphabetically_sorted_topic_magazine_list = $('li[data-type="topic_magazine"]').sort(function (a, b) {
				var innerTextA = a.innerText.toUpperCase();
				var innerTextB = b.innerText.toUpperCase();
				if (innerTextA < innerTextB) {
					return -1;
				}
				if (innerTextA > innerTextB) {
					return 1;
				}
				return 0;
			});
			$('ul.partner-list').append(alphabetically_sorted_topic_magazine_list);
		} else if (filter == 'partner_page') {
			$('button[data-filter="partner_page"]').addClass('btn-neutral-medium-outline-active');
			$('li[data-type="topic_magazine"]').addClass('hidden');
		} else if (filter == 'blank') {
			$('button[data-filter="blank"]').addClass('btn-neutral-medium-outline-active');
		}
	});

	/*
	* GC Selections makes it possible for Subject Matter Experts like Jeff Raikes to "like" a post
	* Added by kala.w @ Giving Tech Labs
	*/

	$('.gc-thumbs-up').on('click', function (e) {

		if ($('.gc-thumbs-up a').hasClass('gc-selection__thumb--black')) {
			$('.gc-thumbs-up a').removeClass('gc-selection__thumb--black').addClass('gc-selection__thumb--green');
		} else if ($('.gc-thumbs-up a').hasClass('gc-selection__thumb--green')) {
			$('.gc-thumbs-up a').removeClass('gc-selection__thumb--green').addClass('gc-selection__thumb--black');
		}
		var post_id = $(this).children().data('post-id');
		var user_id = $(this).children().data('user-id');

		e.preventDefault();

		$.ajax({
			url: ajaxurl,
			type: 'POST',
			data: {
				action: 'gc_ajax_update_gc_selection_status',
				post_id: post_id,
				user_id: user_id
			},
			success: function success(response) {
				var mainImg = $('.col-xs-12.col-lg-8.col-md-stacked-down').find($('.gc-selection')).not($('.item-related .gc-selection'));
				if (response != 0) {
					$(mainImg).removeClass('gc-selection__img--hide');
				} else {
					$(mainImg).addClass('gc-selection__img--hide');
				}
			}
		});
	});

	// If img is too small for hover functionality, remove and use smaller label.
	function gcSelectionSm() {
		var sideImgClass = $('.gc-selection__img');
		var sideImgElement = $('.side-image').find(sideImgClass);
		var sideImgElementParent = $('.side-image').find($(".gc-selection"));
		if (sideImgElement) {
			$(sideImgElement).addClass('gc-selection__img--sm');
			$(sideImgElement).attr("src", "/wp-content/themes/soledad-child/images/icons/gc-selection-cap-sm.svg");
			$(sideImgElementParent).find("span").remove();
		}
	}
	gcSelectionSm();

	// If 'related-post' then make label smaller
	function gcRelatedSm() {
		var relatedImgElement = $('.item-related').find('.gc-selection__img');
		if (relatedImgElement) {
			$(relatedImgElement).addClass('gc-selection__related-img--sm');
			$(relatedImgElement).parent().find("span").remove();
		}
	}
	gcRelatedSm();
	// If img is on Giving Money or Giving Time page, needs to be pushed to the right to fit with background img
	function gcSelectionMove() {
		var ele = $('.gc-selection__img');
		var childEle = $('.mag-content.standard-post-image.col-sm-12.col-md-4').find(ele);
		if (childEle) {
			$(childEle).addClass('gc-selection__img--mv-right');
		}
	}
  gcSelectionMove();

/// GC Code ///

const geoloc = {
	async getGeoLocationByIp(ipAddress) {
		const ajaxArgs = {
			type: 'GET',
			url: '/api/location/ip',
			data: {
				nonce: ajaxVars.nonce,
			}
		};

		return $.ajax(ajaxArgs)
		.then(data => {
			geoloc.setLocationCache(data);
			return data;
		})
		.catch(err => {
			return geoloc.DEFAULT;
		});
	},

	async getGeoLocationByPostal(postalCode) {
		const ajaxArgs = {
			type: 'GET',
			url: '/api/location/search',
			data: {
				nonce: ajaxVars.nonce,
				place: postalCode,
			}
		};

		return $.ajax(ajaxArgs)
		.then(data => {
			geoloc.setLocationCache(data);
			return data;
		})
		.catch(err => {
			return geoloc.DEFAULT;
		});
	},

	async saveLocationProfile (geodata) {
		if (typeof wpUser === 'undefined') { return; }

		let ajaxData = geoloc.transformGeoLocationToSavedLocation(geodata);
		ajaxData.nonce = ajaxVars.nonce;

		const ajaxArgs = {
			type: 'POST',
			url: `/api/user/location`,
			data: ajaxData,
		};

		return $.ajax(ajaxArgs)
		.then(data => {
			return data;
		})
		.catch(err => {
			return '';
		});
	},

	async init () {
		// 1. get geoloc from saved_location
		// else
		// 2. get geoloc from local storage cache
		// else
		// 3. get geoloc from api by ip

		let geoLocation = geoloc.getLocationUserProfile();

		if (!geoLocation)
			geoLocation = geoloc.getLocationCache();
		if (!geoLocation) {
			geoLocation = await geoloc.getGeoLocationByIp();
		}

		geoloc.htmlUpdateLocation(geoLocation);
		geoloc.setSavedLocation(geoLocation);
	},
	getZip() {
		let profile = wpProfile || {};

		if (profile && profile.saved_location && profile.saved_location.City && profile.saved_location.ZIP) {
			return profile.saved_location.ZIP;
		}

		return '';
	},
	getState() {
		let profile = wpProfile || {};

		if (profile && profile.saved_location && profile.saved_location.City && profile.saved_location.ZIP) {
			return profile.saved_location.StateShort || profile.saved_location.StateLong;
		}

		return '';
	},
	setSavedLocation(geoLoc) {
		let profile = wpProfile || {};
		profile.saved_location = geoloc.transformGeoLocationToSavedLocation(geoLoc);
		const { Country: country } = profile.saved_location || {};
		profile.allow_newsletter_signup = country.toLowerCase() == 'us';
	},
	htmlUpdateLocation(geoLocation) {
		const { city, country, subdivisions } = geoLocation;
		const [{code: state} = {}] = subdivisions;
		const location = [city];
		location.push(state || country.code);

		$('.location-status').html(location.join(', '));
		$('.nav-location .fade').addClass('show');
	},
	setLocationCache(data) {
		store.set(geoloc.CACHE_KEY, data, geoloc.CACHE_KEY_EXPIRATION);
	},
	getLocationCache() {
		// If the country code wasn't set throw out the saved location
		const cached = store.get(geoloc.CACHE_KEY);
		const { country: { code: countryCode } = {} } = cached || {};
		return cached && countryCode ? cached : null;
	},
	getLocationUserProfile() {
		if (wpProfile && wpProfile.saved_location) {
			const loc = geoloc.transformSavedLocationToGeoLocation(wpProfile.saved_location);
			geoloc.setLocationCache(loc);
			return loc;
		}
		return '';
	},
	transformSavedLocationToGeoLocation(savedLocation) {
		const loc = savedLocation;
		return {
			city: loc.City,
			continent: {
				code: "",
				name: ""
			},
			country: {
				code: "",
				name: ""
			},
			location: {
				accuracy_radius: 0,
				latitude: loc.Lat,
				longitude: loc.Lng,
				metro_code: "",
				postal_code: loc.ZIP,
				time_zone: ""
			},
			subdivisions: [
				{
					code: loc.StateShort,
					name: loc.StateLong
				}
			],
			traits: {
				network: loc.IP
			}
		}
	},
	transformGeoLocationToSavedLocation(geodata) {
		if (!geodata) { return {}; }

		const subdivision = geodata.subdivisions[0] || {};
		return {
			ZIP: geodata.location.postal_code,
			City: geodata.city,
			StateShort: subdivision.code,
			StateLong: subdivision.name,
			IP: geodata.traits.network,
			Lat: geodata.location.latitude,
			Lng: geodata.location.longitude,
			Country: geodata.country.code,
		}
	},
	CACHE_KEY: 'geoLoc',
	CACHE_KEY_EXPIRATION: Date.now() + (60 * 1000 * 2880), // 2 days
	DEFAULT: {
		city: "Seattle",
		continent: {
			code: "NA",
			name: "North America"
		},
		country: {
			code: "US",
			name: "United States"
		},
		location: {
			accuracy_radius: 20,
			latitude: 47.6109,
			longitude: -122.3303,
			metro_code: "819",
			postal_code: "98101",
			time_zone: "America/Los_Angeles"
		},
		subdivisions: [
			{
				code: "WA",
				name: "Washington"
			}
		],
		traits: {
			network: ""
		}
	},

}

$(document).ready(() => {
    Navbar.toggleNavbarForMobile();
	Navbar.search();
	Footer.updateNewsletterWidget();
	Profile.favorites();
});
